'use client';

import { ConfigurationHeader } from "@/types/configuration";
import Image, { StaticImageData } from "next/image"

interface Props {
    configurationHeader: ConfigurationHeader
}

const SectionHeader: React.FC<Props> = (props: Props) => {

    const renderLogos = () => {
        return props.configurationHeader.logos.map((logo, i) => {
            return (
                <Image src={logo.src} key={`header_logo_${i}`} alt={logo.alt} height={32} />
            );
        })
    }

    return (
        <header className='my-5 mx-5 lg:mx-40'>
            {renderLogos()}
        </header>
    );
}

export default SectionHeader;
